import { firestoreAction } from 'vuexfire'
import db from '../firebase'

const state = {
  cases: [],
  status:{Type:"" ,Text:""},
  casesFetched: false,
}
const getters = {
  cases: (state) => {
    return state.cases
  },
  status: (state) => {
    return state.status
  },  
  casesFetched: (state) => {
    return state.casesFetched
  },

  casesnames: (state) => {
    return state.cases.map(cases => cases.name)
  }
}
const mutations={
  logout_cases(state){
    // // ("Logga ut eht")
    state.cases=[]
    state.casesFetched=false;
      },
}

const actions = {

  logoutCases ({commit}) {
    commit('logout_cases')
},
  initcasesEHT: firestoreAction(({ bindFirestoreRef, state }, schoolId) => {

    bindFirestoreRef('cases', db.collection('cases').where('schoolId', '==', schoolId)).then((res) => {
      state.casesFetched=true;
    })
  }),
  saveCase({},Case){
    if (Case.length!=1) {
      let Step=Case[1]
    Case= Case[0]
    Step.starttime=  Date.now()
    Case.steps.push(Step)
    }
    else
    Case= Case[0]
    //  (Case)
    db.collection('cases').doc(Case.id).update(Case)
  },



  subscribe({state},Lists){
    let New=Lists[0]
    let Gone=Lists[1]
    let id=Lists[2]
    if (New.length!=0)
    New.forEach(NewCase => {//Add to list
      let Case =state.cases.find(Case => Case.name== NewCase)
      Case.subscribersId.push(id)
      db.collection('cases').doc(Case.id).update(Case)
    });
    if (Gone.length!=0) {
    Gone.forEach(OldCase => {//Remove from list
      let Case =state.cases.find(Case => Case.name== OldCase)
      Case.subscribersId= Case.subscribersId.filter(UserId => UserId !=id)
      db.collection('cases').doc(Case.id).update(Case)
    });
  }
  },

  UpdateCase({},Case){
    if (Case.length!=1) {
      let Step=Case[1]
    Case= Case[0]
    Step.starttime=  Date.now()
    Case.steps.push(Step)
    }
    else{
    Case= Case[0]
  }
    db.collection('cases').doc(Case.id).update(Case)
  },

  sendNotice({},Case){
    //  (Case)
    let notice={reporter: Case[0],time:Date.now(), }
    // let CaseID=Case[2]
    Case=Case[1]
    if(Case.hasOwnProperty('notice')==false)
    Case.notice=[];
    Case.notice.push( notice)
    db.collection('cases').doc(Case.id).update(Case)
  },
  clearNotice({},Case){
    Case.notice=[];
    db.collection('cases').doc(Case.id).update(Case)
  },
  removeCase({commit},CaseID){
    //  (CaseID)
    db.collection('cases').doc(CaseID).delete()
  },
  CreateCase({state},teacher){
    // const res = await 
    teacher.steps[0].starttime=  Date.now() 
    //  (teacher)
    db.collection('cases').add(
      teacher
    ).then(() => {
     state.status={Type: "success", Text: "Ärendet har skapats"}
  })
  .catch((error) => {
    state.status={Type: "error", Text: "Error writing document: "+ error}
    // return [false, "Error writing document: "+ error]
  });
    }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
